export class Timeline
{
  start:number;
  end:number;
  bpm:number;
  barLength:number = 4;
}